import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import NProgress from 'nprogress';

const useNProgress = () => {
  const router = useRouter();
  const previousPathRef = useRef(router.asPath);

  useEffect(() => {
    const progressBarParent = document.getElementById('header-progress');
    if (!progressBarParent) return;

    NProgress.configure({
      showSpinner: false,
      speed: 500,
      minimum: 0.3,
      parent: '#header-progress',
    });

    const handleStart = (url) => {
      const isSamePath =
        previousPathRef.current.split('?')[0] === url.split('?')[0];

      if (!isSamePath) {
        NProgress.start();
      }
      previousPathRef.current = url;
    };

    const handleStop = () => {
      NProgress.done();
    };

    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleStop);
    router.events.on('routeChangeError', handleStop);

    return () => {
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleStop);
      router.events.off('routeChangeError', handleStop);
    };
  }, [router]);
};

export default useNProgress;
